import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import AINetwork from './AINetwork';
import { SECTION } from '@/lib/testIds';

export default function CTABand({ title = 'Let\'s build your next growth chapter.', sub = 'Strategy. Technology. Outcomes. One mandate.', ctaLabel = 'Discuss Your Growth Goals', ctaTo = '/contact' }) {
  return (
    <section data-testid={SECTION.ctaBand} className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-[#0B1221] via-[#0B1221] to-[#15082c] p-10 md:p-16">
          <AINetwork density={20} />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <div className="text-xs uppercase tracking-[0.22em] text-cyan-300/80 mb-4">Let&apos;s talk</div>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-balance">
                {title}
              </h2>
              <p className="mt-5 text-base sm:text-lg text-white/70 max-w-xl">{sub}</p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <Link
                to={ctaTo}
                className="btn-shimmer inline-flex items-center gap-3 px-7 py-4 rounded-full bg-cyan-400 text-[#040914] font-semibold hover:bg-cyan-300 transition-colors"
              >
                {ctaLabel}
                <ArrowUpRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
